import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Cleave from 'cleave.js/react';

import { updateFilters } from '../../../../reducers/filtersSlice';

const SurfaceInput = () => {
  const { collection: filtersCollection } = useSelector((state) => state.filters);
  const { surface } = filtersCollection
  const dispatch = useDispatch();

  const cleaveOptions = { numericOnly: true, blocks: [4] }
  const textInputs = [{ inputName: 'min_area', displayName: 'Surface minimum' }, { inputName: 'max_area', displayName: 'Surface maximum' }]

  return(
    <div className='vesta-w-full vesta-surface-inputs'>
      {textInputs.map(({ inputName, displayName }) => (
        <label key={inputName} className='typo-bold-content'>
          {displayName}
          <div className='vesta-currency-wrapper vesta-margin-y-10'>
            <Cleave
              placeholder='-'
              name={inputName}
              className={`vesta-input vesta-input--${inputName}`}
              pattern='[0-9]*'
              value={surface[inputName]}
              options={cleaveOptions}
              onChange={(e) => dispatch(updateFilters(
                {...filtersCollection,
                  surface: {...surface, [inputName]: e.target.value}
                }
              ))}
            />

            <input type='hidden' value='' id={`${inputName}_not_formatted`} />
            <span className='vesta-currency-code typo-content vesta-purple-50'>m²</span>
          </div>
        </label>

      ))}
    </div>
  )
};

export default SurfaceInput;
